// 首页与最近使用共用权限菜单目录，不依赖静态路由配置。
export function buildMenuCatalog(menus = []) {
  const visible = (menu) => menu && menu.visible !== false && menu.meta?.hidden !== true && (menu.status == null || Number(menu.status) === 0) && Number(menu.type) !== 3
  const joinPath = (parent, path) => {
    path = typeof path === 'string' ? path : ''
    if (/^https?:\/\//i.test(path)) return path
    return path.startsWith('/') ? path : `${parent}/${path}`.replace(/\/+/g, '/').replace(/\/$/, '')
  }
  const title = (menu) => menu.name || menu.title || menu.meta?.title || ''
  const coverImage = (menu) => String(menu?.coverImageUrl ?? menu?.cover_image_url ?? menu?.coverImage ?? '').trim()
  return (Array.isArray(menus) ? menus : []).filter(visible).map((root) => {
    const category = { id: String(root.id ?? root.path), title: title(root), items: [] }
    const visit = (menu, parentPath, group) => {
      if (!visible(menu)) return
      const path = joinPath(parentPath, menu.path)
      const children = Array.isArray(menu.children) ? menu.children.filter(visible) : []
      if (children.length) {
        children.forEach(child => visit(child, path, menu === root ? '' : title(menu)))
      } else if (menu.component && path && path !== '/' && !path.includes(':') && !/^https?:/i.test(path)) {
        if (!category.items.some(item => item.path === path)) {
          category.items.push({ menuId: menu.id, path, title: title(menu), category: category.title, categoryId: category.id, group: group || category.title, icon: menu.icon, description: menu.description || '', coverImageUrl: coverImage(menu), openInNewTab: path === '/chat/agent' })
        }
      }
    }
    visit(root, '', '')
    return category
  }).filter(category => category.items.length)
}

export function parseRecentVisits(raw) {
  try {
    const entries = JSON.parse(raw || '[]')
    if (!Array.isArray(entries)) return []
    const paths = new Set()
    return entries.filter(entry => entry && typeof entry.path === 'string' && Number.isFinite(entry.visitedAt))
      .sort((a, b) => b.visitedAt - a.visitedAt).filter(entry => {
      if (paths.has(entry.path)) return false
      paths.add(entry.path)
      return true
    }).slice(0, 20)
  } catch { return [] }
}

export function addRecentVisit(entries, path, visitedAt = Date.now()) {
  return [{ path, visitedAt }, ...entries.filter(entry => entry.path !== path)].slice(0, 20)
}
